import requestCommon from "@/components/web-interface/requestCommon";
const state = {
  variationDetails: null,
  variationNameReference: null,
};
const actions = {
  getVariationDetails(context, data) {
    
    return requestCommon.getInfo(
      "/variations/" + data.variationId + "/" + data.type,
      data,
      null,
      context,
      "getVariationDetailsSuccessHandler",
      "getVariationDetailsErrorHandler"
    );
  },
  getVariationNameReference(context, data) {
    return requestCommon.getInfo(
      "/variations/reference/" + data.type,
      data,
      null,
      context,
      "getVariationNameReferenceSuccessHandler",
      "getVariationNameReferenceErrorHandler"
    );
  },
  createNewVariables(context, data) {
    return requestCommon.postInfo(
      "/variations/" + data.variationId + "/" + data.type,
      null,
      data,
      context,
      "createNewVariablesSuccessHandler",
      "createNewVariablesErrorHandler",
    );
  },
  updateVariables(context, data) {
    return requestCommon.patchInfo(
      "/variations/" + data.variationId + "/" + data.type,
      null,
      data,
      context,
      "updateVariablesSuccessHandler",
      "updateVariablesErrorHandler",
    );
  },
}
const mutations = {
  getVariationDetailsSuccessHandler(state, data) {
    console.log('Received data:', data);
    state.variationDetails = data.server.data;
  },
  getVariationDetailsErrorHandler(context, error) {
    console.log(error);
  },
  getVariationNameReferenceSuccessHandler(state, data) {
    console.log('Received data:', data);
    state.variationNameReference = data.server.data;
  },
  getVariationNameReferenceErrorHandler(context, error) {
    console.log(error);
  },
  createNewVariablesSuccessHandler(state, data) {
    console.log('created data:', data);
  },
  createNewVariablesErrorHandler(context, error) {
    console.log(error);
  },
  updateVariablesSuccessHandler(state, data) {
    console.log('update data:', data);
  },
  updateVariablesErrorHandler(context, error) {
    console.log(error);
  }
};
const getters = {};
export const variationStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}